document.addEventListener("DOMContentLoaded", function () {
    // Verificar si ya se mostró el video hoy
    const lastShown = localStorage.getItem("youtubeModalLastShown");
    const today = new Date().toISOString().split("T")[0]; // Formato YYYY-MM-DD

    // Solo mostrar el modal si no se ha mostrado hoy
    if (!lastShown) {
        // Crear el modal
        const modal = document.createElement("div");
        modal.id = "youtube-modal";
        modal.classList.add(
            "fixed",
            "inset-0",
            "z-[100]",
            "flex",
            "items-center",
            "justify-center",
            "bg-black/80",
            "backdrop-blur-sm",
            "opacity-0",
            "invisible",
            "transition-all",
            "duration-300"
        );

        // Contenido del modal
        modal.innerHTML = `
            <div class="flex flex-col items-center w-full max-w-screen-lg px-6 relative">
                <h2 class="text-white text-xl md:text-2xl font-bold mb-4 uppercase">Registrations are open!</h2>
                <div class="relative w-full max-w-4xl mx-4 md:mx-auto aspect-video">
                <iframe
                    width="100%"
                    height="100%"
                    src="https://www.youtube.com/embed/ubCkoh3BEcg?autoplay=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
                </div>
                <div class="flex gap-4 mt-8">
                    <a id="more-info-button" href="/post/inscripciones-marisquino-2025" class="px-4 py-2 bg-white hover:bg-gray-100 text-black font-medium text-sm transition-colors duration-300 transform hover:scale-105">
                        Más información
                    </a>
                    <button id="close-youtube-modal" class="px-4 py-2 border border-white hover:text-black hover:bg-white text-white font-medium text-sm transition-colors duration-300 transform hover:scale-105">
                        Cerrar
                    </button>
                </div>
            </div>
        `;

        // Añadir el modal al body
        document.body.appendChild(modal);

        // Mostrar el modal después de un pequeño retraso
        setTimeout(() => {
            modal.classList.remove("opacity-0", "invisible");
        }, 1000);

        // Cerrar el modal al hacer clic en el botón de cerrar
        document
            .getElementById("close-youtube-modal")
            .addEventListener("click", function () {
                closeModal();
            });

        // Cerrar el modal y marcar como visto al hacer clic en "Más información"
        document
            .getElementById("more-info-button")
            .addEventListener("click", function () {
                // Solo marcamos como visto, no cerramos el modal ya que navegaremos a otra página
                localStorage.setItem("youtubeModalLastShown", today);
            });

        // Cerrar el modal al presionar Escape
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape") {
                closeModal();
            }
        });

        // Variables para detectar scroll
        let lastScrollTop = 0;
        let scrollSpeed = 0;
        const scrollThreshold = 30; // Umbral de velocidad de scroll para cerrar el modal

        // Evento de scroll para detectar scroll y cerrar el modal
        window.addEventListener(
            "scroll",
            function (e) {
                const st =
                    window.pageYOffset || document.documentElement.scrollTop;

                // Calcular la velocidad del scroll
                scrollSpeed = Math.abs(st - lastScrollTop);

                // Si el scroll supera el umbral, cerrar el modal
                if (scrollSpeed > scrollThreshold) {
                    closeModal();
                }

                lastScrollTop = st <= 0 ? 0 : st; // Para móviles
            },
            false
        );

        // Función para cerrar el modal
        function closeModal() {
            const modal = document.getElementById("youtube-modal");
            modal.classList.add("opacity-0", "invisible");

            // Eliminar el modal después de la transición
            setTimeout(() => {
                if (modal && modal.parentNode) {
                    modal.parentNode.removeChild(modal);
                }
            }, 300);

            // Guardar la fecha actual en localStorage
            localStorage.setItem("youtubeModalLastShown", today);
        }
    }
});
